<template>
  <family-page-wrapper class="family-gourmet-history">
    <div
      v-if="isOrderEmpty"
      class="order-empty-notification"
    >
      Please call us at
      <a href="tel:+18554646872">1-855-464-6872</a>
      if you would like to place your first order!
    </div>

    <transactions @set-empty-order="isOrderEmpty = $event" />
    <saved-delivery-orders />
  </family-page-wrapper>
</template>

<script setup lang="ts">
import { ref, defineAsyncComponent } from 'vue';

const Transactions = defineAsyncComponent(() => import('../Operator/DeliveryTransactions.vue') as any);

const SavedDeliveryOrders = defineAsyncComponent(() => import('./SavedDeliveryOrders.vue') as any);

const isOrderEmpty = ref(false);
</script>

<style lang="scss">
.family-gourmet-history {
  .order-empty-notification {
    max-width: 960px;
    font-size: 18px;
    margin-bottom: 20px;
    text-align: center;
    color: #f00;

    a {
      color: #080fef;
      text-decoration: underline;
    }
  }
}
</style>
